import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const POLICIES = [
  {
    id: "deposit",
    title: "Custom Order Deposit",
    body: "A 50% non-refundable deposit is required to confirm your custom order and secure your place in the order queue — payable by e-transfer, Square or PayPal. Work will not begin until the deposit has been received. The remaining balance is due before pickup, delivery or shipping.",
  },
  {
    id: "cancellations",
    title: "Cancellations & Refunds",
    body: "Changed your mind? Please get in touch as soon as possible. If work on your order has not yet started, you may cancel — however, the 50% deposit is non-refundable. Once work on your order has begun, cancellations and refunds are not available.",
  },
  {
    id: "personalized",
    title: "Personalized Items",
    body: "Items made with names, initials, specific measurements or other personalized details are final sale once work has begun. Please double-check all names, sizes, colours and customization details before approving your order.",
  },
  {
    id: "handmade",
    title: "Handmade Variation",
    body: "Because each item is handmade, slight variations in size, colour placement and appearance may occur. These small differences are part of what makes handmade pieces unique and are not considered defects.",
  },
  {
    id: "problems",
    title: "Problems With Your Order",
    body: "If I've made an error or your item has a workmanship issue, please contact me within 7 days of receiving your order. I'll work with you to make it right through a repair, replacement or other appropriate solution. Normal wear and tear, accidental damage, improper washing/care, or damage after the item has been received is not considered a workmanship defect.",
  },
  {
    id: "abandoned",
    title: "Abandoned Orders",
    body: "Completed orders must be picked up and paid for within 30 days of notification that they're ready, unless other arrangements have been made. If an order is not collected and I'm unable to reach you, the deposit remains non-refundable and the item may be made available for resale.",
  },
  {
    id: "delivery",
    title: "Pickup, Delivery & Shipping",
    body: "Pickup is available in the Guelph–Waterloo region (evenings and weekends work best). Local delivery within the Wellington–Waterloo region is a $5 flat fee. I also ship anywhere in Canada and the US — shipping cost is simply added to your total.",
  },
  {
    id: "pattern-credits",
    title: "Pattern Credits & Disclaimer",
    body: "Some of the crochet pieces featured on Double Treble Stitches are made using paid or free patterns created by other talented designers, while others are my own original creations. I always strive to respect and credit pattern designers where applicable. If you're curious about the pattern used for a particular item, please feel free to reach out — I'd be happy to let you know whether a pattern is available and where you can find it.",
  },
];

export default function Policies() {
  return (
    <section id="policies" data-testid="policies-section" className="bg-blend-oat py-20 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-8">
        <Reveal className="text-center">
          <Eyebrow testId="policies-eyebrow">Good to Know</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl font-medium leading-[1.15] tracking-tight text-[#2C2520] sm:text-4xl lg:text-5xl">
            The fine print, <span className="italic text-[#A35C45]">written kindly.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-[#6E6259] sm:text-base">
            Every item is handmade with care and created especially for you — here&apos;s how orders, deposits and pickups work.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-12">
            {POLICIES.map((p) => (
              <AccordionItem key={p.id} value={p.id} className="border-[#E6DFD5]">
                <AccordionTrigger
                  data-testid={`policy-trigger-${p.id}`}
                  className="py-5 text-left font-serif text-xl font-medium tracking-tight text-[#2C2520] hover:text-[#A35C45] hover:no-underline"
                >
                  {p.title}
                </AccordionTrigger>
                <AccordionContent data-testid={`policy-content-${p.id}`} className="text-sm leading-relaxed text-[#6E6259] sm:text-base">
                  {p.body}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
